import type { ReactNode } from "react";

/**
 * The house underline-field classes — the impl detail of the office `Input`
 * (which adds `w-full`), also composed by the field widgets whose control
 * can't be an `<Input>` (SearchSelect/Combobox, MoneyAmount, a native
 * `<select>` styled as a field, TagInput's chip wrapper). Width is layout —
 * the caller appends its own (`w-full`, `w-28 shrink-0`). The disabled look
 * is nobody's to append: globals.css greys every disabled field, house or
 * hand-rolled, in one rule.
 */

/** The underline field WITHOUT its vertical padding, for a control that pads
 *  its own contents instead — a chip field, whose box is a flex row and whose
 *  real line box belongs to the input inside it. Padding the box AND the
 *  input inside it is how the category field came to stand 4px taller than
 *  the sku beside it. */
export const INPUT_FRAME_CLS =
  "border-b border-line bg-transparent px-1 font-mono text-sm text-fg outline-none focus:border-fg";

export const INPUT_CLS = `${INPUT_FRAME_CLS} py-1.5`;

/** The mono eyebrow label above an `Input`/`Select`/`Textarea` in a form
 *  (subtle tone). Use instead of a hand-written
 *  `<span className="label !text-fg-subtle">` ("fix once, fix everywhere"). */
export function FieldLabel({
  children,
  className = "",
}: {
  children: ReactNode;
  className?: string;
}) {
  return (
    <span className={`label !text-fg-subtle ${className}`.trim()}>
      {children}
    </span>
  );
}
